const DeviceManagementReducer = (state = {}, action) => {
  switch (action.type) {
    case "getSearchDeviceSuccess": {
      return Object.assign({}, state, {
        SearchDevice: action.data,
      });
      break;
    }
    case "getClientShipListSuccess": {
      return Object.assign({}, state, {
        ClientShipLists: action.data,
      });
      break;
    }

    case "getClientShippingCompanyListSuccess": {
      return Object.assign({}, state, {
        ClientShipLists2: action.data,
      });
      break;
    }
      
      case "ShipcompanyName": {
        return Object.assign({}, state, {
          ShipcompanyName: action.data,
        });
        break;
      }

    case "getSearchDeviceFailure":
      return Object.assign({}, state, {
        SearchDevice: action.data,
      });
      break;
    case "getDeviceDetailsSuccess": {
      return Object.assign({}, state, {
        DeviceDetails: action.data,
      });
      break;
    }
    case "getDeviceDetailsFailure":
      return Object.assign({}, state, {
        DeviceDetails: action.data,
      });
      break;
    case "postAddDeviceSuccess": {
      return Object.assign({}, state, {
        AddDevice: action.data,
      });
      break;
    }
    case "postAddDeviceFailure":
      return Object.assign({}, state, {
        AddDevice: action.data,
      });
      break;
    case "putUpdateDeviceSuccess": {
      return Object.assign({}, state, {
        UpdateDevice: action.data,
      });
      break;
    }
    case "putUpdateDeviceFailure":
      return Object.assign({}, state, {
        UpdateDevice: action.data,
      });
      break;
    case "DeviceDetails": {
      return Object.assign({}, state, {
        DeviceDetails: action.data,
      });
      break;
    }
    default: {
      return state;
    }
  }
};
export default DeviceManagementReducer;
